import { render, staticRenderFns } from "./QuickDeclareButtonSet.vue?vue&type=template&id=799896f0&"
import script from "./QuickDeclareButtonSet.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareButtonSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports